import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

export default new Middleware(
	'Check authenticated permissions',
	({ next, to, from }) => {
		if (
			to.matched.some(record => record.meta.permissions) &&
			store.getters['Auth/authenticated']
		) {
			let canView = false
			// Find the deepest (most specific) route that has permissions defined
			const deepestRouteWithPermissions = [...to.matched]
				.reverse()
				.find(record => record.meta.permissions && record.meta.permissions.length > 0)
			const matchedRouteWithPermissionRedirect = [...to.matched]
				.reverse()
				.find(record => record.meta.permissionRedirect)

			if (deepestRouteWithPermissions) {
				const permissionMethod = deepestRouteWithPermissions.meta.permissionMethod || 'hasSomePermission'
				const matchMethod = deepestRouteWithPermissions.meta.permissionMatch === 'some' ? 'some' : 'every'
				const user = store.getters['Auth/user']
				if (!user || typeof user[permissionMethod] !== 'function') {
					return next({ name: 'Dashboard:Home' })
				}
				canView = deepestRouteWithPermissions.meta.permissions[matchMethod](permission =>
					user[permissionMethod](permission)
				)
			}

			if (!canView) {
				const redirectTarget = deepestRouteWithPermissions?.meta?.permissionRedirect || matchedRouteWithPermissionRedirect?.meta?.permissionRedirect
				if (redirectTarget) {
					if (typeof redirectTarget === 'function') {
						const resolved = redirectTarget(to, from)
						if (resolved) {
							return next(resolved)
						}
						// If redirect function returns falsy, fall through to home
						return next({ name: 'Dashboard:Home' })
					} else {
						return next(redirectTarget)
					}
				}
				return next({ name: 'Dashboard:Home' })
			} else {
				return next()
			}
		} else {
			return next()
		}
	}
)
